module.exports = __webpack_public_path__ + "images/agro03-b3cbf9ca7a586c1479a5af2017647c35.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/agro03.jpeg
// module id = 224
// module chunks = 0